import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LoadingService } from '../../../core/services/loading.service';

@Component({
  selector: 'app-loading-bar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (loading.isLoading()) {
      <div class="loading-bar" role="progressbar" aria-label="Loading">
        <div class="loading-bar__progress"></div>
      </div>
    }
  `,
  styles: `
    .loading-bar {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 3px;
      z-index: 9999;
      overflow: hidden;
      background: rgba(3, 162, 151, 0.15);
    }

    .loading-bar__progress {
      height: 100%;
      width: 40%;
      background: #03a297;
      border-radius: 0 2px 2px 0;
      animation: loading-slide 1.2s ease-in-out infinite;
    }

    @keyframes loading-slide {
      0% {
        transform: translateX(-100%);
      }
      100% {
        transform: translateX(350%);
      }
    }
  `,
})
export class LoadingBar {
  protected loading = inject(LoadingService);
}
